import { useCallback, useState } from 'react';
import { CapTablesService } from 'api/services/CapTablesService';
import { useStore } from 'common/store';
import { getObjectValue, Logger } from 'utilities';

export const useCashFlowLedgerExport = () => {
  const [{ captableInfo }] = useStore();
  const { id: capTableId } = getObjectValue(captableInfo);
  const [isExporting, setIsExporting] = useState(false);

  const exportCashFlowLedger = useCallback(async () => {
    if (!capTableId) {
      Logger.warn('No cap table ID available for export');
      return;
    }

    setIsExporting(true);
    try {
      // Use clientWithAuth directly to support blob responseType
      const response = await CapTablesService.apiCapTablesCashFlowLedgerExportList(capTableId);

      // Create a download link for the blob
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;

      // Try to extract filename from Content-Disposition header
      const contentDisposition = response.headers['content-disposition'];
      let filename = `Cash_Flow_Ledger_${capTableId}_${new Date().toISOString().split('T')[0]}.xlsx`;
      if (contentDisposition) {
        const [, extractedFilename] = contentDisposition.match(/filename="?([^";\n]+)"?/) || [];
        if (extractedFilename) {
          filename = extractedFilename;
        }
      }

      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();

      // Cleanup
      link.parentNode?.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      Logger.error('Error exporting cash flow ledger:', error);
      throw error;
    } finally {
      setIsExporting(false);
    }
  }, [capTableId]);

  return {
    exportCashFlowLedger,
    isExporting,
    canExport: Boolean(capTableId),
  };
};
